import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation, SimpleChanges, OnChanges } from "@angular/core";
import * as _ from 'lodash';
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import moment from "moment";
import { startWith, pairwise } from 'rxjs/operators';
import { FormsErrorsService } from '../../../services/forms-error.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: "mapfre-auditlib-item",
   templateUrl: "./item.component.html",
   styleUrls: ["./item.component.scss"],
   encapsulation: ViewEncapsulation.None
})
export class ItemComponent implements OnChanges {
   _data: { [key: string]: any } = { };
   _columns;
   changing: boolean = false;
   currentLang;
   checked: boolean = true;

   @Input()
   get data() {
      return this._data;
   }
   set data(value) {      
      this._data = this.parseBtnData(value)
   }

   @Input()
   get columns() {
      return this._columns;
   }
   set columns(value) {
      this._columns = value;
   }

   _selectData;
   @Input()
   get selectData() {
      return this._selectData;
   }
   set selectData(value) {
      this._selectData = value;
      setTimeout(() => this.selectDataChange.emit(this._selectData));
   }

   form: UntypedFormGroup;
   @Input() edit;
   @Input() actions;
   @Input() defaultActions;
   @Input() defaultValidators = [];
   @Input() nuuma;

   @Input() selectTable;
   @Input() typeSelect;

   @Output() selectDataChange = new EventEmitter();
   @Output() actionClicked = new EventEmitter();
   @Output() selectChange = new EventEmitter();
   @Output() updated = new EventEmitter();
   @Output() created = new EventEmitter();
   @Output() deleted = new EventEmitter();

   @Input() collapsed = false;
   constructor(private formsErrorService: FormsErrorsService, private translateService: TranslateService) {
      this.currentLang = this.translateService.currentLang;
   }

   parseBtnData(data: { [key: string]: any }) {
      if(!_.has(data, 'editBtn')){
         data.editBtn = true;
      }
      if(!_.has(data, 'deleteBtn')){
         data.deleteBtn = true;
      }
      return data;
    }

   ngOnChanges(change: SimpleChanges) {
      /*if(change.selectData){
      this.checkItem();
    }*/
      this.createFormGroup();
      this.checkItem();

   }

   getIcon(name) {
      name = _.lowerCase(name);

      if (_.includes(name, 'xls')) {
         return 'icon-24-px-doc-excel green-excel';
      }

      if (_.includes(name, 'pdf')) {
         return 'icon-24-px-doc-pdf red-pdf';
      }

      if (_.includes(name, 'ppt')) {
         return 'icon-24-px-doc-ppt orange-ppt';
      }

      if (_.includes(name, 'doc')) {
         return 'icon-24-px-doc-word blue-doc';
      }

      return 'icon-24-px-comunicacion';

   }

   checkItem() {
      if (this.selectTable) {
         this.checked = _.some(this._selectData, item => {
            return _.isEqual(item, this._data);
         });
      }
   }

   onSelectChange(event) {
      this.selectChange.emit(event);
   }

   createFormGroup() {
      this.form = new UntypedFormGroup({}, { validators: this.defaultValidators });
      this._columns?.forEach(element => {

         let initValue = element.options && element.options.field ? _.get(this._data, element.options.field) : _.get(this._data, element.field);

         if (element.type === "date") {
            initValue =
               _.get(this._data, element.field) && _.get(element, "options.selectionMode") === "single"
                  ? moment(_.get(this._data, element.field), 'YYYY-MM-DD').toDate()
                  : _.get(this._data, element.field);

            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         } else if (element.type === "select") {
            if (_.get(this._data, element.field)) {
               initValue = _.get(this._data, element.field);
            }
            else {
               if (element.options.selectionMode === "simple") {
                  initValue = null;
               }
               else {
                  initValue = [];
               }
            }


            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         } else if (element.type === "boolean") {
            initValue = _.has(this._data, element.field) ? _.get(this._data, element.field) : true
            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         } else {
            this.form.addControl(element.field, new UntypedFormControl(initValue, element.validators));
         }
      });

      this.subscribe();
   }

   subscribe() {
      /*this.form.valueChanges.pipe(startWith(null), pairwise())
         .subscribe(([prev, next]: [any, any]) => {
            //if we're not changing state we manage the data flow
            if (prev !== null && !_.isEqual(prev, next)) {
               _.forEach(this.columns, column => {
                  //If column is a simple select, convert array to object
                  if (column.type !== 'number') {
                     _.set(this._data, column.field, this.form.get(column.field).value);
                  }
                  else {
                     if (this.form.get(column.field).value !== '') {
                        _.set(this._data, column.field, this.form.get(column.field).value);
                     }
                  }
               });
               this.createFormGroup();
            }
         });*/
   }

   toggleEdit() {
      this.edit = !this.edit;
      this.edit ? this.actionClicked.emit("edit") : this.actionClicked.emit("stopEdit")
      //Si se ha cancelado la edición se resetea el form
      if (!this.edit) {
         this.createFormGroup();
      }
   }
   onCancelled() {
      if (this._data.hasOwnProperty("edit")) {
         this.actionClicked.emit("cancelled");
      }
      this.toggleEdit();
   }

   onSave() {
      if (this.form.valid) {
         let formValue = this.form.value;
         if (this._data.hasOwnProperty("edit")) {
            this.created.emit(formValue);
         } else {
            this.updated.emit(formValue);
         }
         this.toggleEdit();
      } else {
         this.form.markAllAsTouched();
         this.formsErrorService.notifyVisible(true);
      }
   }

   onActionClicked(action) {
      this.actionClicked.emit(action.key);
   }

   onDelete() {
      this.deleted.emit(this._data);
   }

   get(object, field) {
      return field ? _.get(object, field) : object;
   }

   selectSimpleClick(event) {
      if (event) {
         this.selectData = [];
         this.selectData.push(this._data);
      } else {
         _.remove(this.selectData, this._data);
      }
      //this.selectDataChange.emit(this.selectData)
   }

   getFlag(object, field) {
      return _.get(object, field) ? "./assets/flags/" + _.get(object, field).toLowerCase() + ".png" : "";
   }

   selectMultipleClick(event) {
      if (event) {
         this.selectData.push(this._data);
      } else {
         _.remove(this.selectData, this._data);
      }
      this.selectDataChange.emit(this.selectData);
   }

   getName(name) {
      if (name) {
         return name
      } else {
         return this.nuuma
      }
   }

   getDate(date) {
      if (date) {
         return date
      } else {
         return new Date();
      }
   }
   showList(dataList, field) {
      let temp: string = ``;
      let valueTranslated: string = ``;
      for (let data of dataList) {
         let value = this.get(data, field)
         valueTranslated = this.translateService.instant(value.toString());
         // temp += `<span style="color:white;">${valueTranslated}</span><br>`;
      }
      // return temp;
      return valueTranslated;

   }
}
